import { useState, useMemo } from 'react';
import { IntlMessages } from '../../../helper/langHelper';
import {
  CompanyContainer,
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
} from '../../../services/settings/appStyle/global.style';
import {
  CountButton,
  CountButtonWrapper,
  Panel,
  PanelContent,
  PanelSection,
  PremisesItem,
  PremisesList,
  PremisesText,
  // Select,
  ServiceDescription,
  ServiceDetails,
  ServiceHeader,
  ServiceItem,
  TotalCost,
  TotalCostAmount,
  TotalCostText,
  Wrapper,
} from './subscriptionAddOn.style';
import { ButtonWrapper } from '../SubscriptionPlanV2/Subscription.style';
import { Button, Label, Loader } from '../../../Components/uielements';
import { useQuery } from 'react-query';
import SubscriptionPlanService from '../../../services/bioplus-services/subscription-plan';
import { useUserContext } from '../../../hooks/UserContext';
import { chekout } from '../../../services/bioplus-services/subscription';
import CheckBoxField from '../../../Components/form-fields/checkBox';
import {
  EmptyStateContainer,
  StyledEmptyStateText,
  TableEmptyState,
} from '../../../Components/uielements/table/table.style';
import { EmptyState } from '../../../Components/icons';

const SubscriptionAddOn = () => {
  const [userClick, setUserClick] = useState(1);
  const [timesheetClick, setTimesheetClick] = useState(1);
  const [ecvdClick, setEcvdClick] = useState(1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAddOns, setSelectedAddOns] = useState([]);

  // api calls
  const query = useQuery(['subscriptionPlans', page, pageSize], () =>
    SubscriptionPlanService.getPlans(page, pageSize)
  );
  const subscriptionPlans = query?.data?.filter((plan) => plan?.type === 'addOn') ?? [];

  const handleIncrementQuantity = (type) => {
    switch (type) {
      case 'user':
        setUserClick(userClick + 1);
        break;
      case 'timesheet':
        setTimesheetClick(timesheetClick + 1);
        break;
      case 'edec':
        setEcvdClick(ecvdClick + 1);
        break;
      default:
        break;
    }
  };

  const handleDecrementQuantity = (type) => {
    switch (type) {
      case 'user':
        setUserClick(Math.max(1, userClick - 1));
        break;
      case 'timesheet':
        setTimesheetClick(Math.max(1, timesheetClick - 1));
        break;
      case 'edec':
        setEcvdClick(Math.max(1, ecvdClick - 1));
        break;
      default:
        break;
    }
  };

  const totalCost = useMemo(() => {
    return subscriptionPlans.reduce((acc, plan) => {
      switch (plan?.addOn) {
        case 'user':
          return acc + plan?.baseCost * userClick;
        case 'timesheet':
          return acc + plan?.baseCost * timesheetClick;
        case 'edec':
          return acc + plan?.baseCost * ecvdClick;
        default:
          return acc;
      }
    }, 0);
  }, [subscriptionPlans, userClick, timesheetClick, ecvdClick]);

  const { company } = useUserContext();

  const handleCheckBox = (addOn) => {
    setSelectedAddOns((prevSelectedAddOns) => {
      if (prevSelectedAddOns?.includes(addOn)) {
        return prevSelectedAddOns?.filter((item) => item !== addOn);
      } else {
        return [...prevSelectedAddOns, addOn];
      }
    });
  };

  const handleMakePayment = async () => {
    try {
      setIsLoading(true);
      const payload = {
        mode: 'subscription',
        companyName: company?.companyId?.name,
        companyId: company?.companyId?.id,
        lineItems: subscriptionPlans
          ?.filter((item) => selectedAddOns.includes(item.addOn))
          .map((item) => {
            let quantity = 0;
            if (item.addOn === 'user') {
              quantity = userClick;
            } else if (item.addOn === 'timesheet') {
              quantity = timesheetClick;
            } else if (item.addOn === 'edec') {
              quantity = ecvdClick;
            }
            return {
              price: item.priceId,
              quantity: quantity,
            };
          }),
      };
      const response = await chekout(payload);
      if (response) {
        setIsLoading(false);
        window.open(response, '_blank');
      }
    } catch (error) {
      setIsLoading(false);
      alert('Oops! We encountered an error. Please try again later.');
      console.error('Error making payment:', error);
    }
  };

  if (query.isLoading || isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }
  return (
    <StyledContainer className="hide-scroll-bar">
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="page.header.addOn" />
        </HeaderTitle>
      </CompanyContainer>
      {subscriptionPlans && subscriptionPlans?.length > 0 ? (
        <Wrapper>
          <Panel>
            <PanelSection>
              <PanelContent>
                <PremisesList>
                  {subscriptionPlans?.map((plan, index) => (
                    <PremisesItem key={index}>
                      <div
                        style={{
                          display: 'flex',
                          gap: '20px',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <PremisesText>#{index + 1}</PremisesText>
                        <div>
                          <div style={{ fontSize: '20px ', textDecoration: 'uppercase' }}>
                            {plan?.name} - $
                            <span style={{ fontSize: '24px' }}>{plan?.baseCost}</span>
                          </div>
                          <div className="text-[#63678C] text-xs">
                            Monthly / Quantity- {plan?.qty} {plan?.addOn}
                          </div>
                        </div>
                      </div>
                      <div>
                        <CheckBoxField
                          name={plan?.addOn}
                          onClick={() => handleCheckBox(plan?.addOn)}
                          checked={selectedAddOns?.includes(plan?.addOn)}
                        />
                      </div>
                    </PremisesItem>
                  ))}
                </PremisesList>
              </PanelContent>
            </PanelSection>
            <PanelSection>
              <PanelContent>
                {/* <ServiceItem>
                <Label size="header3" htmlFor="premises">
                  SELECT PREMISE
                </Label>
                <Select id="premises">
                  <option>#123 SUMMER STREET, GEELONG</option>
                </Select>
              </ServiceItem> */}
                {subscriptionPlans?.map((plan, index) => (
                  <ServiceItem key={index}>
                    <ServiceHeader>
                      <ServiceDetails>
                        <Label size="header3" transform="uppercase">
                          {plan?.addOn}
                        </Label>
                        <ServiceDescription>
                          ${plan?.baseCost} PER {plan?.qty} {plan?.addOn} / PER MONTH (INC. GST)
                        </ServiceDescription>
                      </ServiceDetails>
                      <CountButtonWrapper>
                        <CountButton
                          onClick={() => handleDecrementQuantity(plan?.addOn)}
                          className={
                            (plan?.addOn === 'user' && userClick === 1) ||
                            (plan?.addOn === 'timesheet' && timesheetClick === 1) ||
                            (plan?.addOn === 'edec' && ecvdClick === 1)
                              ? 'disabled'
                              : ''
                          }
                          disabled={
                            (plan?.addOn === 'user' && userClick === 1) ||
                            (plan?.addOn === 'timesheet' && timesheetClick === 1) ||
                            (plan?.addOn === 'edec' && ecvdClick === 1)
                          }
                        >
                          -{plan?.qty}
                        </CountButton>
                        <div>
                          {plan?.addOn === 'user' && userClick * plan?.qty}
                          {plan?.addOn === 'timesheet' && timesheetClick * plan?.qty}
                          {plan?.addOn === 'edec' && ecvdClick * plan?.qty}
                        </div>
                        <CountButton onClick={() => handleIncrementQuantity(plan?.addOn)}>
                          +{plan?.qty}
                        </CountButton>
                      </CountButtonWrapper>
                    </ServiceHeader>
                  </ServiceItem>
                ))}
              </PanelContent>
              <div style={{ paddingTop: '12px' }}></div>
              <TotalCost>
                <TotalCostText>
                  <Label size="header3">TOTAL COST</Label>
                  <ServiceDescription>PER MONTH (INC. GST)</ServiceDescription>
                </TotalCostText>
                <TotalCostAmount>
                  <span>$</span>
                  {totalCost}
                </TotalCostAmount>
              </TotalCost>
              <ButtonWrapper>
                <Button
                  varient="normal"
                  onClick={handleMakePayment}
                  disabled={selectedAddOns?.length <= 0}
                >
                  <IntlMessages id="button.make.payment" />
                </Button>
              </ButtonWrapper>
            </PanelSection>
          </Panel>
        </Wrapper>
      ) : (
        <>
          <TableEmptyState>
            <>
              <EmptyStateContainer>
                <EmptyState />
              </EmptyStateContainer>
              <StyledEmptyStateText size="header3">
                <IntlMessages id="common.empty.state" defaultMessage="No Record Found" />
              </StyledEmptyStateText>
            </>
          </TableEmptyState>
        </>
      )}
    </StyledContainer>
  );
};

export default SubscriptionAddOn;
